module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "cotacaoContainer",
    staticClass: "box-body cronogramaff"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    directives: [{
      name: "confirm",
      rawName: "v-confirm",
      value: ({
        ok: function (retorno) { return _vm.deleteTodos('ok'); },
        cancel: _vm.doNothing,
        message: 'Deseja <b>APAGAR</b> todos os itens ?'
      }),
      expression: "{ok: retorno => deleteTodos('ok'), cancel: doNothing, message: 'Deseja <b>APAGAR</b> todos os itens ?'}"
    }],
    staticClass: "btn btn-primary btn-sm btn-flat",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   Apagar todos os itens do cronograma\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.propsAtividades), function(atividade, atividadeIndex) {
    return [_c('tr', {
      staticClass: "atividade"
    }, [_c('td', {
      staticClass: "centralizado borda"
    }, [_vm._v("\n                  Tipo Cotação\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "esquerda borda nome_atividade",
      attrs: {
        "colspan": _vm.proposta.ds_fase === 'ANALISE' ? 2 : 2
      }
    }, [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), _c('td', {
      staticClass: "centralizado borda"
    }, [_vm._v(_vm._s(atividade.nr_periodo_inicial))]), _vm._v(" "), _c('td', {
      staticClass: "centralizado borda"
    }, [_vm._v(_vm._s(atividade.nr_periodo_final))]), _vm._v(" "), _c('td', {
      staticClass: "direita borda",
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(_vm._f("real")(_vm.somaTotal(atividade.itens_orcamentos))))]), _vm._v(" "), _c('td', {
      staticClass: "centralizado borda"
    }, [(!_vm.editando && !_vm.adicionando) ? _c('button', {
      staticClass: "btn btn-primary btn-sm btn-flat",
      attrs: {
        "disable": _vm.bloqueiaBotoes,
        "type": "button",
        "id": "financial-physical-activity-0f"
      },
      on: {
        "click": function($event) {
          return _vm.addItem(atividade, atividadeIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Adicionar\n                  ")]) : _vm._e()])]), _vm._v(" "), _vm._l((atividade.itens_orcamentos), function(item, itemIndex) {
      return _c('tr', {
        attrs: {
          "prefix": "activityItem",
          "suffix": "item.id",
          "row": "item"
        }
      }, [(!item.editando) ? [_c('td', {
        staticClass: "centralizado borda w5",
        class: _vm.verificaValidacao(item)
      }, [(item.itemCotacao && item.itemCotacao[0] !== undefined) ? _c('div', {
        staticClass: "cotacao-tipo"
      }, [(item.itemCotacao[0].length > 0) ? _c('div', [_c('i', {
        staticClass: "fa fa-plus-circle"
      }), _vm._v(" Cotação Automática\n                      ")]) : _vm._e(), _vm._v(" "), (item.itemCotacaoManual[0].length > 0) ? _c('div', [_c('i', {
        staticClass: "fa fa-cubes"
      }), _vm._v(" Cotação Manual\n                      ")]) : _vm._e()]) : _c('div', {
        staticClass: "cotacao-tipo"
      }, [_c('i', {
        staticClass: "fa fa-recycle"
      }), _vm._v(" Cotação Manual Antiga\n                    ")])]), _vm._v(" "), _c('td', {
        staticClass: "centralizado borda w10",
        class: _vm.verificaValidacao(item)
      }, [(('' + item.origem) === '1') ? _c('span', [_vm._v("Fundação")]) : (('' + item.origem) === '2') ? _c('span', [_vm._v("Contrapartida")]) : (('' + item.origem) === '5') ? _c('span', [_vm._v("Parceiro Estratégico")]) : _vm._e(), _vm._v(" "), (('' + item.adiantavel) === '1') ? _c('span', [_c('br'), _vm._m(2, true)]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "borda",
        class: _vm.verificaValidacao(item)
      }, [_c('div', {
        staticClass: "item"
      }, [_c('div', {
        class: (_vm.propostaDentroFbb && item.conta_financeira ? 'w50' : 'w100') + ' item_despesa esquerda'
      }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), (_vm.propostaDentroFbb && item.conta_financeira) ? _c('div', {
        staticClass: "direita"
      }, [_vm._v(_vm._s(item.conta_financeira.numero_conta) + " / " + _vm._s(item.conta_financeira.descricao))]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "observacao esquerda"
      }, [_vm._v(_vm._s(item.observacao))])])]), _vm._v(" "), _c('td', {
        staticClass: "centralizado borda w5",
        class: _vm.verificaValidacao(item)
      }, [_vm._v(_vm._s(item.periodo_inicial))]), _vm._v(" "), _c('td', {
        staticClass: "centralizado borda w5",
        class: _vm.verificaValidacao(item)
      }, [_vm._v(_vm._s(item.periodo_final))]), _vm._v(" "), _c('td', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            inertia: true,
            arrow: true,
            animation: 'perspective',
            distance: '1',
            size: 'large',
            arrow: true
          }),
          expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
        }],
        staticClass: "centralizado borda w5",
        class: _vm.verificaValidacao(item),
        attrs: {
          "title": '<h5>' + (!_vm._.has(item, 'unidade_medida') || _vm._.isNull(item.unidade_medida) ? 'Sem unid. de medida' : (item.unidade_medida === 'Outros' && _vm._.has(item, 'medida_outros') && !_vm._.isNull(item.medida_outros) ? ('Outros:<br/>' + item.medida_outros) : item.unidade_medida)) + '</h5>'
        }
      }, [_vm._v("\n                    " + _vm._s(item.quantidade) + "\n                  ")]), _vm._v(" "), _c('td', {
        staticClass: "centralizado borda w10",
        class: _vm.verificaValidacao(item)
      }, [_vm._v(_vm._s(_vm._f("real")(item.valor_unitario)))]), _vm._v(" "), _c('td', {
        staticClass: "centralizado borda w10",
        class: _vm.verificaValidacao(item)
      }, [_vm._v(_vm._s(_vm._f("real")(item.quantidade * item.valor_unitario)))]), _vm._v(" "), _c('td', {
        staticClass: "row-flex all-centered gap-5 acoes-coluna",
        class: _vm.verificaValidacao(item)
      }, [(!_vm.editando && !_vm.adicionando) ? _c('div', {
        staticClass: "row-flex all-centered gap-5"
      }, [_c('b-button', {
        staticClass: "btn btn-primary btn-sm btn-flat",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.bloqueiaBotoes ? null : _vm.editaItem(atividade, atividadeIndex, item, itemIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil-square-o",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
        directives: [{
          name: "confirm",
          rawName: "v-confirm",
          value: ({
            ok: function (retorno) { return _vm.deleteItem(atividade, atividadeIndex, item, itemIndex); },
            cancel: _vm.doNothing,
            message: 'Deseja <b>APAGAR</b> o item ' + item.item.ds_code + '-' + item.item.ds_description + ', da atividade ' + atividade.ds_nome + ' ?'
          }),
          expression: "{ok: retorno => deleteItem(atividade, atividadeIndex, item, itemIndex), cancel: doNothing,\n                         message: 'Deseja <b>APAGAR</b> o item ' + item.item.ds_code + '-' + item.item.ds_description + ', da atividade ' + atividade.ds_nome + ' ?'}"
        }],
        staticClass: "btn btn-danger btn-sm btn-flat",
        attrs: {
          "type": "button"
        },
        on: {
          "click": _vm.bloqueiaBotoes
        }
      }, [_c('i', {
        staticClass: "fa fa-trash",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Excluir")])], 1) : _vm._e(), _vm._v(" "), (!_vm.editando && !_vm.adicionando && item.itemCotacao) ? _c('div', {
        staticClass: "row-flex all-centered gap-5"
      }, [(item.itemCotacaoValidado.validado) ? _c('b-button', {
        staticClass: "btn btn-success btn-sm btn-flat",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.bloqueiaBotoes ? null : _vm.abrirCotacaoValidacao(item, true)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-shopping-cart",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Abrir Cotação")]) : _vm._e(), _vm._v(" "), (!item.itemCotacaoValidado.validado && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('b-button', {
        staticClass: "btn btn-warning btn-sm btn-flat",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.bloqueiaBotoes ? null : _vm.abrirCotacaoValidacao(item, false)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-exclamation-triangle",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Validar Cotação")]) : _vm._e(), _vm._v(" "), (!item.itemCotacaoValidado.validado && _vm.usuarioLogado.userType === 'ENTIDADE') ? _c('b-button', {
        staticClass: "btn btn-warning btn-sm btn-flat",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            _vm.bloqueiaBotoes ? null : _vm.abrirCotacaoValidacao(item, true)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-exclamation-triangle",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Abrir Cotação")]) : _vm._e()], 1) : _vm._e()])] : _vm._e(), _vm._v(" "), [(_vm.validarCotacao && item.itemCotacao) ? _c('div', {
        staticClass: "animated fadeInDownOutUp edicaoItem"
      }, [_c('cotacaoItens', {
        attrs: {
          "idProposta": _vm.proposta.id,
          "fk_cotacao": _vm.itemForm.fk_cotacao,
          "cotacaoGravada": _vm.itemForm.itemCotacao,
          "cotacaoManualGravada": _vm.itemForm.itemCotacaoManual,
          "editarCotacao": _vm.editarCotacao,
          "validandoCotacao": _vm.validarCotacao,
          "visualizandoCotacao": _vm.visualizandoCotacao,
          "cotacaoValidada": _vm.itemForm.itemCotacaoValidado,
          "setDescricaoValor": _vm.setDescricaoValor,
          "toggleCotacao": _vm.toggleCotacao,
          "fecharValidacao": _vm.fecharValidacao,
          "atividadeIndex": atividadeIndex,
          "itemIndex": itemIndex,
          "onAdd": _vm.onAdd,
          "atividade": atividade,
          "item": _vm.itemForm,
          "gravarValidacaoRow": _vm.gravarValidacaoRow
        }
      })], 1) : _vm._e()], _vm._v(" "), (item.editando) ? [_c('td', {
        attrs: {
          "colspan": "10"
        }
      }, [_c('div', {
        staticClass: "animated fadeInDownOutUp edicaoItem"
      }, [(_vm.abrirSistemaCotacao) ? _c('cotacaoItens', {
        attrs: {
          "idProposta": _vm.proposta.id,
          "fk_cotacao": _vm.itemForm.fk_cotacao,
          "cotacaoGravada": _vm.itemForm.itemCotacao,
          "cotacaoManualGravada": _vm.itemForm.itemCotacaoManual,
          "editarCotacao": _vm.editarCotacao,
          "cotacaoValidada": _vm.itemForm.itemCotacaoValidado,
          "setDescricaoValor": _vm.setDescricaoValor,
          "toggleCotacao": _vm.toggleCotacao,
          "fecharValidacao": _vm.fecharValidacao,
          "atividadeIndex": atividadeIndex,
          "itemIndex": itemIndex,
          "onAdd": _vm.onAdd,
          "atividade": atividade,
          "item": item,
          "gravarValidacaoRow": _vm.gravarValidacaoRow
        }
      }) : _vm._e()], 1), _vm._v(" "), (!_vm.abrirSistemaCotacao && !_vm.abrirSistemaCotacaoManual) ? _c('div', {
        staticClass: "animated fadeInDownOutUp edicaoItem"
      }, [_c('div', {
        staticClass: "form-group row"
      }, [_c('div', {
        staticClass: "required",
        class: {
          'has-error': _vm.errors.first('origem')
        }
      }, [_c('label', {
        staticClass: "control-label col-md-2"
      }, [_vm._v("Origem:")]), _vm._v(" "), _c('div', {
        staticClass: "col-md-5"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.itemForm.origem),
          expression: "itemForm.origem"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        staticClass: "form-control",
        attrs: {
          "name": "origem",
          "aria-label": "origem"
        },
        on: {
          "change": [function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.itemForm, "origem", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }, function($event) {
            return _vm.zeraAdiantamento()
          }]
        }
      }, [_c('option', {
        attrs: {
          "value": "1"
        }
      }, [_vm._v("Fundação")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "2"
        }
      }, [_vm._v("Contrapartida")]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('option', {
        attrs: {
          "value": "5"
        }
      }, [_vm._v("P.Estratégico")]) : _vm._e()]), _vm._v(" "), (_vm.errors.first('origem')) ? _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v(" " + _vm._s(_vm.errors.first('origem')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-1"
      }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
        staticClass: "required",
        class: {
          'has-error': _vm.errors.first('inicio')
        }
      }, [_c('label', {
        staticClass: "control-label col-md-1"
      }, [_vm._v("Início:")]), _vm._v(" "), _c('div', {
        staticClass: "col-md-1"
      }, [_c('div', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.itemForm.periodo_inicial),
          expression: "itemForm.periodo_inicial"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        ref: "periodo_inicial",
        refInFor: true,
        staticClass: "form-control text-right",
        attrs: {
          "type": "number",
          "name": "inicio",
          "maxlength": "2",
          "aria-label": "Inicio do período",
          "min": atividade.inicio,
          "max": atividade.termino
        },
        domProps: {
          "value": (_vm.itemForm.periodo_inicial)
        },
        on: {
          "change": _vm.validaPeriodo,
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.itemForm, "periodo_inicial", $event.target.value)
          }
        }
      })]), _vm._v(" "), (_vm.errors.first('inicio')) ? _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v(" " + _vm._s(_vm.errors.first('inicio')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticClass: "required",
        class: {
          'has-error': _vm.errors.first('fim')
        }
      }, [_c('label', {
        staticClass: "control-label col-md-1"
      }, [_vm._v("Fim:")]), _vm._v(" "), _c('div', {
        staticClass: "col-md-1"
      }, [_c('div', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.itemForm.periodo_final),
          expression: "itemForm.periodo_final"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        ref: "periodo_final",
        refInFor: true,
        staticClass: "form-control text-right",
        attrs: {
          "type": "number",
          "name": "fim",
          "maxlength": "2",
          "aria-label": "Fim do período",
          "min": atividade.inicio,
          "max": atividade.termino
        },
        domProps: {
          "value": (_vm.itemForm.periodo_final)
        },
        on: {
          "change": _vm.validaPeriodo,
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.itemForm, "periodo_final", $event.target.value)
          }
        }
      })]), _vm._v(" "), (_vm.errors.first('fim')) ? _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v(" " + _vm._s(_vm.errors.first('fim')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
        staticClass: "form-group row"
      }, [_c('div', {
        staticClass: "required",
        class: {
          'has-error': _vm.errors.first('item')
        }
      }, [_c('label', {
        staticClass: "control-label col-md-2"
      }, [_vm._v("Item de despesa:")]), _vm._v(" "), _c('div', {
        staticClass: "col-md-10"
      }, [_c('div', {
        attrs: {
          "approval": "finPhySchFormCtrl.approval",
          "state": "finPhySchFormCtrl.approvalState"
        }
      }, [_c('multiselect', {
        directives: [{
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        attrs: {
          "name": "item",
          "custom-label": _vm.itemCodigo,
          "searchable": true,
          "options": _vm.items,
          "close-on-select": true,
          "hide-selected": true,
          "preserve-search": false,
          "placeholder": "Escolha um item",
          "disabled": _vm.itemForm.origem === null,
          "label": "ds_description",
          "track-by": "ds_code",
          "preselect-first": false
        },
        on: {
          "select": function($event) {
            return _vm.buscaContasFinanceiras($event)
          }
        },
        scopedSlots: _vm._u([{
          key: "option",
          fn: function(props) {
            return [_c('div', {
              staticClass: "option__desc"
            }, [_c('span', {
              staticClass: "option__title"
            }, [_vm._v(_vm._s(props.option.ds_code) + " / " + _vm._s(props.option.ds_description))])])]
          }
        }], null, true),
        model: {
          value: (_vm.itemForm.item),
          callback: function($$v) {
            _vm.$set(_vm.itemForm, "item", $$v)
          },
          expression: "itemForm.item"
        }
      }, [_vm._v(" "), _c('span', {
        attrs: {
          "slot": "noResult"
        },
        slot: "noResult"
      }, [_c('font', {
        attrs: {
          "color": "red"
        }
      }, [_vm._v("Nenhum registro localizado!")])], 1)])], 1), _vm._v(" "), (_vm.errors.first('item')) ? _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v(" " + _vm._s(_vm.errors.first('item')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
        staticClass: "form-group row"
      }, [_c('div', {
        staticClass: "required",
        class: {
          'has-error': _vm.errors.first('descrição item')
        }
      }, [_c('label', {
        staticClass: "control-label col-md-2"
      }, [_vm._v("Descrição Item:")]), _vm._v(" "), _c('div', [_c('div', {
        staticClass: "col-md-10"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.itemForm.observacao),
          expression: "itemForm.observacao"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "name": "descrição item",
          "maxlength": "255",
          "aria-label": "Descrição do item"
        },
        domProps: {
          "value": (_vm.itemForm.observacao)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.itemForm, "observacao", $event.target.value)
          }
        }
      }), _vm._v(" "), (_vm.errors.first('descrição item')) ? _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v(" " + _vm._s(_vm.errors.first('descrição item')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
        staticClass: "form-group row"
      }, [_c('div', {
        staticClass: "required",
        class: {
          'has-error': _vm.errors.first('quantidade')
        }
      }, [_c('label', {
        staticClass: "control-label col-md-2"
      }, [_vm._v("Quantidade:")]), _vm._v(" "), _c('div', {
        staticClass: "col-md-1"
      }, [_c('div', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.itemForm.quantidade),
          expression: "itemForm.quantidade"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required|min_value:1'),
          expression: "'required|min_value:1'"
        }],
        staticClass: "form-control text-right",
        attrs: {
          "type": "number",
          "name": "quantidade",
          "min": "1",
          "maxlength": "6",
          "aria-label": "Quantidade do recurso"
        },
        domProps: {
          "value": (_vm.itemForm.quantidade)
        },
        on: {
          "change": function($event) {
            return _vm.valorTotal(_vm.itemForm)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.itemForm, "quantidade", $event.target.value)
          }
        }
      })]), _vm._v(" "), (_vm.errors.first('quantidade')) ? _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v(" " + _vm._s(_vm.errors.first('quantidade')))]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col-sm-2"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.itemForm.unidade_medida),
          expression: "itemForm.unidade_medida"
        }],
        staticClass: "form-control",
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.itemForm, "unidade_medida", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((_vm.medidas), function(unidade_medida) {
        return _c('option', {
          domProps: {
            "value": unidade_medida
          }
        }, [_vm._v(_vm._s(unidade_medida))])
      }), 0)]), _vm._v(" "), (_vm.itemForm.unidade_medida === 'Outros') ? _c('div', {
        staticClass: "col-md-2 required-field",
        class: {
          'has-error': _vm.errors.first('medida outros')
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.itemForm.medida_outros),
          expression: "itemForm.medida_outros"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }, {
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            inertia: true,
            arrow: true,
            animation: 'perspective',
            distance: '1',
            size: 'large',
            arrow: true
          }),
          expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
        }],
        staticClass: "form-control text-right",
        attrs: {
          "type": "text",
          "name": "medida outros",
          "maxlength": "255",
          "aria-label": "Outros",
          "title": '<h5>Qual essa outra unidade de medida?</h5>'
        },
        domProps: {
          "value": (_vm.itemForm.medida_outros)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.itemForm, "medida_outros", $event.target.value)
          }
        }
      }), _vm._v(" "), (_vm.errors.first('medida outros')) ? _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v(" " + _vm._s(_vm.errors.first('medida outros')))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "required",
        class: {
          'has-error': _vm.errors.first('valor unitario')
        }
      }, [_c('label', {
        staticClass: "control-label col-md-1"
      }, [_vm._v("Valor Unitário:")]), _vm._v(" "), _c('div', {
        staticClass: "col-md-2"
      }, [_c('div', [_c('money', {
        directives: [{
          name: "validate",
          rawName: "v-validate",
          value: ('required|min_value:0.01'),
          expression: "'required|min_value:0.01'"
        }],
        staticClass: "form-control text-right",
        attrs: {
          "disabled": "",
          "name": "valor unitario"
        },
        on: {
          "change": function($event) {
            return _vm.valorTotal(_vm.itemForm)
          }
        },
        model: {
          value: (_vm.itemForm.valor_unitario),
          callback: function($$v) {
            _vm.$set(_vm.itemForm, "valor_unitario", $$v)
          },
          expression: "itemForm.valor_unitario"
        }
      }), _vm._v(" "), _c('span', [_vm._v("Valor cotado: " + _vm._s(_vm._f("real")(_vm.itemForm.valor_cotado)) + " "), _c('i', {
        staticClass: "fa fa-question-circle",
        attrs: {
          "aria-hidden": "true",
          "title": "Valor médio dos preços cotados, ou da soma das médias, se houver mais de um produto/serviço"
        }
      })])], 1), _vm._v(" "), (_vm.errors.first('valor unitario')) ? _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v(" " + _vm._s(_vm.errors.first('valor unitario')) + " \n                              \n                            ")]) : _vm._e()]), _vm._v(" "), _c('b-button', {
        staticClass: "btn btn-primary btn-sm btn-flat",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.abrirCotacao()
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-plus-circle",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Adicionar/Editar Cotação")])], 1), _vm._v(" "), _c('div', {
        staticClass: "row-flex all-end w-100"
      }, [_c('label', {
        staticClass: "control-label col-md-2"
      }, [_vm._v("Valor Total: " + _vm._s(_vm._f("real")((_vm.itemForm.quantidade * _vm.itemForm.valor_unitario))))])])]), _vm._v(" "), _c('div', {
        staticClass: "form-group row"
      }, [(_vm.proposta.ds_fase === 'ANALISE') ? _c('div', {
        staticClass: " required",
        class: {
          'has-error': _vm.errors.first('adiantavel')
        }
      }, [_c('label', {
        staticClass: "control-label col-md-2"
      }, [_vm._v("Adiantável:")]), _vm._v(" "), _c('div', {
        staticClass: "col-md-2"
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.itemForm.adiantavel),
          expression: "itemForm.adiantavel"
        }, {
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        staticClass: "form-control",
        attrs: {
          "disabled": _vm.itemForm.origem === '2' || _vm.itemForm.origem === 2,
          "name": "adiantavel",
          "required": ""
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.itemForm, "adiantavel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "0"
        }
      }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "1"
        }
      }, [_vm._v("Sim")])]), _vm._v(" "), (_vm.errors.first('adiantavel')) ? _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v(" " + _vm._s(_vm.errors.first('adiantavel')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.propostaDentroFbb()) ? _c('div', {
        staticClass: "required",
        class: {
          'has-error': _vm.errors.first('conta financeira')
        }
      }, [_c('label', {
        staticClass: "control-label col-md-2"
      }, [_vm._v("Conta Financeira:")]), _vm._v(" "), _c('div', {
        staticClass: "col-md-6"
      }, [_c('multiselect', {
        directives: [{
          name: "validate",
          rawName: "v-validate",
          value: ('required'),
          expression: "'required'"
        }],
        attrs: {
          "disabled": _vm.blockSelect === true,
          "name": "conta financeira",
          "custom-label": _vm.contaCodigo,
          "options": _vm.contasFinanceiras,
          "close-on-select": true,
          "hide-selected": true,
          "preserve-search": false,
          "placeholder": "Escolha um item",
          "label": "numero_conta",
          "track-by": "numero_conta",
          "preselect-first": false
        },
        on: {
          "select": _vm.selecionaConta
        },
        scopedSlots: _vm._u([{
          key: "option",
          fn: function(props) {
            return [_c('div', {
              staticClass: "option__desc"
            }, [_c('span', {
              staticClass: "option__title"
            }, [_vm._v(_vm._s(props.option.numero_conta) + " / " + _vm._s(props.option.descricao))])])]
          }
        }], null, true),
        model: {
          value: (_vm.itemForm.conta_financeira),
          callback: function($$v) {
            _vm.$set(_vm.itemForm, "conta_financeira", $$v)
          },
          expression: "itemForm.conta_financeira"
        }
      }, [_vm._v(" "), _c('span', {
        attrs: {
          "slot": "noResult"
        },
        slot: "noResult"
      }, [_c('font', {
        attrs: {
          "color": "red"
        }
      }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('conta financeira')) ? _c('span', {
        staticClass: "label label-danger"
      }, [_vm._v(" " + _vm._s(_vm.errors.first('conta financeira')))]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "form-group row"
      }, [_c('div', {
        staticClass: "col-md-10 col-md-offset-2"
      }, [_c('button', {
        ref: "financial-physical-save-item",
        refInFor: true,
        staticClass: "btn btn-confirm btn-flat",
        class: {
          disabled: _vm.submitDisabled
        },
        attrs: {
          "id": "financial-physical-save-item",
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.onAdd(atividade, item, itemIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-check",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-back btn-flat",
        attrs: {
          "id": "financial-physical-cancel-item",
          "type": "button"
        },
        on: {
          "~click": function($event) {
            return _vm.cancelaItem(atividade, item, itemIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times-circle",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Cancelar")])])])]) : _vm._e()])] : _vm._e()], 2)
    })]
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "totais"
  }, [_c('tr', [_c('td', {
    staticClass: "centralizado"
  }, [(_vm.totais.projeto.fbb !== 0) ? _c('span', [_vm._v("Total Fundação")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [(_vm.totais.projeto.parceiros !== 0) ? _c('span', [_vm._v("Total Parceiro Estratégico")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [(_vm.totais.projeto.contrapartida !== 0) ? _c('span', [_vm._v("Total Contrapartida")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [(_vm.totais.adiantavel.total !== 0) ? _c('span', [_vm._v("Total Adiantável")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total do Projeto")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.fbb !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Total da Fundação R$ <span class=\'realce\'>' + (_vm.totais.projeto.fbb).toFixed(2) + '</span> distribuídos em <span class=\'realce\'>' + _vm.totais.itens.fbb + '</span> itens, compondo aprox. <span class=\'realce\'>' + (Math.round((_vm.totais.projeto.fbb / _vm.totais.projeto.total) * 100) | _vm.percent) + '%</span> do total do projeto</h5>'
    }
  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.projeto.fbb)))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.parceiros !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Total de Parceiro Estratégico R$ <span class=\'realce\'>' + (_vm.totais.projeto.parceiros).toFixed(2) + '</span> distribuídos em <span class=\'realce\'>' + _vm.totais.itens.parceiros + '</span> itens, compondo aprox. <span class=\'realce\'>' + (Math.round((_vm.totais.projeto.parceiros / _vm.totais.projeto.total) * 100) | _vm.percent) + '%</span> do total do projeto</h5>'
    }
  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.projeto.parceiros)))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.contrapartida !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Total da Contrapartida R$ <span class=\'realce\'>' + (_vm.totais.projeto.contrapartida).toFixed(2) + '</span> distribuídos em <span class=\'realce\'>' + _vm.totais.itens.contrapartida + '</span> itens, compondo aprox. <span class=\'realce\'>' + (Math.round((_vm.totais.projeto.contrapartida / _vm.totais.projeto.total) * 100) | _vm.percent) + '%</span> do total do projeto</h5>'
    }
  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.projeto.contrapartida)))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.adiantavel.total !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Total Adiantável R$ <span class=\'realce\'>' + _vm.totais.adiantavel.total + '</span>, sendo R$ <span class=\'realce\'>' + _vm.totais.adiantavel.fbb + '</span> da Fundação e R$ <span class=\'realce\'>' + _vm.totais.adiantavel.parceiros + '</span> de Parc. Estratégico</h5>'
    }
  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.adiantavel.total)))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Total do Projeto R$ <span class=\'realce\'>' + _vm.totais.projeto.total + '</span> distribuídos em <span class=\'realce\'>' + _vm.totais.itens.total + '</span> itens</h5>'
    }
  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.totais.projeto.total)))])])])])])]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('table', {
    staticClass: "totais",
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('tr', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "text-align": "center",
      "vertical-align": "baseline"
    }
  }, [_c('p', [_c('span', [_vm._v(" Investimento "), _c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "Produtos, obra civil, seguros e IPVA"
    }
  })])]), _vm._v(" "), _c('p', [_c('span', [_c('strong', [_vm._v(" " + _vm._s((_vm.totalInvestimento / (_vm.totalInvestimento + _vm.totalCusteio) * 100).toFixed(0)) + "% ")])])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(" " + _vm._s(_vm._f("real")(_vm.totalInvestimento)) + " ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "1px",
      "text-align": "center",
      "vertical-align": "baseline"
    }
  }, [_c('p', [_c('span', [_vm._v(" Custeio "), _c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-info-circle",
    attrs: {
      "title": "O que não for investimento"
    }
  })])]), _vm._v(" "), _c('p', [_c('span', [_c('strong', [_vm._v(" " + _vm._s((_vm.totalCusteio / (_vm.totalInvestimento + _vm.totalCusteio) * 100).toFixed(0)) + "% ")])])]), _vm._v(" "), _c('p', [_c('span', [_vm._v(" " + _vm._s(_vm._f("real")(_vm.totalCusteio)) + " ")])]), _vm._v(" "), _c('p', [_vm._v("\n              Capacitação e assessoria\n              "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" " + _vm._s(((_vm.totalCapacitacao + _vm.totalAssessoria) / (_vm.totalInvestimento + _vm.totalCusteio) * 100).toFixed(0)) + "% ")]), _vm._v("\n              (" + _vm._s(_vm._f("real")(_vm.totalCapacitacao + _vm.totalAssessoria)) + ")\n            ")])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-flex centered-start legenda-container"
  }, [_c('div', {
    staticClass: "row-flex all-centered gap-5"
  }, [_c('div', {
    staticClass: "validado-legenda legenda-box"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "title": "CV menor de 25%"
    }
  }, [_vm._v("\n            Validação Automática\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-centered gap-5"
  }, [_c('div', {
    staticClass: "validado legenda-box"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Cadastrado no Busca Preços mas com CV maior que 25% ou Remoção Manual de Itens"
    }
  }, [_vm._v("\n            Automático com validação manual\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-centered gap-5"
  }, [_c('div', {
    staticClass: "validado-manual legenda-box"
  }), _vm._v(" "), _c('div', [_vm._v("\n            Manual Validado\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-centered gap-5"
  }, [_c('div', {
    staticClass: "legado-legenda legenda-box"
  }), _vm._v(" "), _c('div', [_vm._v("\n            Cotação Manual Antiga\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-centered gap-5"
  }, [_c('div', {
    staticClass: "pendente-validacao-legenda legenda-box"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "title": "CV acima de 25% / Cotação Manual / Remoções manuais"
    }
  }, [_vm._v("\n            Pendente de validação\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "cabecalho"
  }, [_c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Tipo Cotação")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Atividade / Itens do Cronograma")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Período"), _c('br'), _vm._v("Início / Fim")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Valor Unitário")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Valor Total")]), _vm._v(" "), _c('th', [_vm._v(" ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('i', [_vm._v("Adiantável")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c608dd7e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/comparativoPrecos/cronogramaCotacao.vue
// module id = 2075
// module chunks = 1